export const toggleDevice = device => {
  return {
    type: 'TOGGLE_DEVICE',
    device,
  };
};
